


































import { defineComponent, ref } from '@vue/composition-api';

const SubLayerCheckbox: object = defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: true,
      name: 'checked',
    },
    icon: {
      type: String,
      // eslint-disable-next-line global-require
      default: 'icomoon-layers-events',
      name: 'icon',
    },
    label: {
      type: String,
      default: '<BRAK DANYCH>',
      name: 'label',
    },
    parentState: {
      type: Boolean,
      default: true,
      name: 'parentState',
    },
  },
  name: 'SubLayerCheckbox',
  setup() {
  },
});
export default SubLayerCheckbox;
